export default "__VITE_ASSET__ChJQUCHu__"